export default __webpack_public_path__ + "static/ja-cac94b4a31ca2daac05a0eddabd83ce0.webp";